import { useCallback } from 'react'
import { useTracking } from 'react-tracking'

interface useTrackEventErrorProps {
    codeError: string
    message: string
    value?: string
    access: string
    accessType?: string
}

export function useTrackEventError() {
    const { trackEvent } = useTracking()

    const handleTrackEventError = useCallback(
        ({ access, codeError, message, value, accessType }: useTrackEventErrorProps) => {
            trackEvent({
                event: 'log_login_error',
                access,
                access_type: accessType ? accessType : value?.length! <= 8 ? 'lab' : 'nav',
                code: codeError,
                message,
                time: new Date().toISOString(),
                fullurl: window.location.href,
            })
        },
        [trackEvent],
    )

    return {
        handleTrackEventError,
    }
}
